export default __webpack_public_path__ + "static/media/android-o.c3efc789.svg";